module.exports = __webpack_public_path__ + "static/media/jenny-strecker-personal-trainer.dcb9e48b.jpg";